import { render, Suspense, useState } from '@wordpress/element';
import Search from './search';
import CartPreview from './cart-preview';
import Notice from './notice';

function SwiftCart() {
	const { swiftCartTranslations } = window.QalaB2bWholesale.translations;
	const [ cartPreviewItems, setCartPreviewItems ] = useState( [] );
	const [ addingToCartPreview, setAddingToCartPreview ] = useState( false );
	const [ clearCart, setClearCart ] = useState( true );
	const [ addingToCart, setAddingToCart ] = useState( false );
	const [ noticeContent, setNoticeContent ] = useState( {
		message: '',
		type: '',
	} );

	const setItemQuantity = ( id, newQuantity ) => {
		setCartPreviewItems( prevState => prevState.map( item => {
			if ( item.id === id ) {
				item.quantity = newQuantity;
			}

			return item;
		} ) );
	};

	const removeItem = id => {
		setCartPreviewItems( prevState => prevState.filter( item => item.id !== id ) );
	};

	const addItemsToCart = async () => {
		setAddingToCart( true );

		const { _wpnonce } = window.QalaB2bWholesale.swiftCartObj;

		try {
			const response = await fetch( '/wp-json/qala-b2b-wholesale/v1/swift-cart/add-to-cart', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': _wpnonce,
				},
				body: JSON.stringify( {
					products: cartPreviewItems,
					clearCart,
				} ),
			} );

			const jsonBody = await response.json();

			if ( response.ok ) {
				setNoticeContent( {
					message: jsonBody.message,
					type: 'message',
				} );
				setCartPreviewItems( [] );

				// Trigger the mini cart button click event if it exists.
				const miniCartButton = document.querySelector( '[data-mini-cart-button]' );
				if ( miniCartButton ) {
					miniCartButton.click();
				}
			} else {
				setNoticeContent( {
					message: jsonBody.message,
					type: 'error',
				} );

				if ( jsonBody.failed && jsonBody.failed.length > 0 ) {
					setCartPreviewItems( prevState => prevState.map( item => {
						if ( jsonBody.failed.includes( item.id ) ) {
							item.hasError = true;
						}

						return item;
					} ) );
				}
			}
		} catch ( e ) {
			setNoticeContent( {
				message: swiftCartTranslations.genericError,
				type: 'error',
			} );
		}

		setAddingToCart( false );
	};

	return <>
		<Search setCartPreviewItems={ setCartPreviewItems } setNoticeContent={ setNoticeContent } setAddingToCartPreview={ setAddingToCartPreview } />
		{ noticeContent.message.length > 0 && <Notice message={ noticeContent.message } type={ noticeContent.type } /> }
		<CartPreview items={ cartPreviewItems } setItemQuantity={ setItemQuantity } removeItem={ removeItem } addingToCartPreview={ addingToCartPreview } />
		{ cartPreviewItems.length > 0 && <>
			<label htmlFor="qala-b2b-wholesale-swift-cart-clear-cart" className="qala-b2b-wholesale-swift-cart-clear-cart">
				<input type="checkbox" id="qala-b2b-wholesale-swift-cart-clear-cart" checked={ clearCart } onChange={ () => setClearCart( ! clearCart ) } />
				<span>{ swiftCartTranslations.removeExistingProductsFromCart }</span>
			</label>
			<button
				className="qala-b2b-wholesale-swift-cart-add-button"
				onClick={ addItemsToCart }
				disabled={ addingToCart }
			>{ addingToCart ? swiftCartTranslations.addingToCart : swiftCartTranslations.addToCart }
			</button>
		</> }
	</>;
}

window.addEventListener( 'DOMContentLoaded', () => {
	const element = document.querySelector(
		'.qala-b2b-wholesale-swift-cart'
	);

	if ( element ) {
		render(
			<Suspense fallback={ <div className="wp-block-placeholder" /> }>
				<SwiftCart />
			</Suspense>,
			element
		);
	}
} );
